import React, { useState } from "react";
import { HeroSlideshow } from "@/components/home/HeroSlideshow";
import { SHIP_SLIDES } from "@/data/site";

/*
 * Hero background video: a Sora-2 generated cinematic clip of a single cargo ship
 * sailing the open ocean, looped. Falls back to the animated real-ship slideshow
 * if the video is unavailable.
 */
export const HeroVideo = () => {
  const [failed, setFailed] = useState(false);

  if (failed) return <HeroSlideshow />;

  return (
    <div className="absolute inset-0 overflow-hidden bg-brand-deep">
      <video
        className="absolute inset-0 h-full w-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        poster={SHIP_SLIDES[0]}
        onError={() => setFailed(true)}
      >
        <source src={`${process.env.PUBLIC_URL}/hero-bg.mp4`} type="video/mp4" />
      </video>
    </div>
  );
};
